import { React } from 'react'
import AnimatedText from './AnimatedText'
import ProfilePic from '../assets/me.jpg'



export const HeroSection = () => {

  // Download resume
  const handleResumeDownload = () => {
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');  // To open in new tab
    link.href = "https://drive.google.com/file/d/1qEACgPkJOKiXyzb77v746sihP_fyO8Hs/view?usp=sharing"
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  return (
    <div className="bg-gradient-to-br from-light to-[#e0e0e0] dark:from-dark dark:to-[#252525]
                    p-8 md:p-12 lg:p-16 xl:p-24">

      <div className='items-center flex flex-col lg:flex-row'>
        
        {/* Picture */}
        <div className='w-[70%] lg:w-1/2 mx-10'>
          <img src={ProfilePic} alt="portrait"
                className='h-auto inline-block lg:w-full rounded-2xl shadow-2xl border-4 border-primary' />
        </div>


        {/* Description */}
        <div className='flex flex-col items-center self-center w-full lg:w-1/2'>
          
          <p className='mt-2 mb-0 font-medium w-full
                        text-xs md:text-sm lg:text-base
                        text-center lg:text-left dark:text-light'>
            Hello, I'm
          </p>

          <AnimatedText text="Eduard Tiron"
                        className='!text-center lg:!text-left
                                  !text-3xl md:!text-5xl lg:!text-6xl xl:!text-5xl' />
          
          <p className='my-4 font-medium w-full
                        text-xs md:text-sm lg:text-base
                        text-center lg:text-left dark:text-light'>
            Software engineer | DevOps engineer | Mechatronics engineer
          </p>

          <p className='my-4 font-medium  w-full
                        text-xs md:text-sm lg:text-base
                        text-center lg:text-left dark:text-light'>
            Engineer with experience across full-stack web development, cloud infrastructure, and industrial automation — from React frontends and Kubernetes pipelines to PLC-controlled machines and embedded C++.
          </p>


          {/* Buttons */}
          <div className='flex items-center mt-2 self-center lg:self-start'>

            <a href="mailto:Eduard.Tiron@gmail.com" target="_blank" rel="noreferrer"
               className='flex items-center rounded-lg font-semibold
                          p-2 px-4 md:p-2.5 md:px-6 mr-2
                          text-sm md:text-base
                          transition-colors duration-300
                          first-letter: bg-dark text-light hover:bg-light hover:text-dark
                          border-2 border-solid border-dark hover:border-dark
                          dark:bg-light dark:text-dark dark:border-light dark:hover:bg-dark dark:hover:text-light dark:hover:border-light'>
              Email me
            </a>

            <button href="/" target="_blank" rel="noreferrer"
              className='flex items-center rounded-lg font-semibold
                         p-2 px-4 md:p-2.5 md:px-6
                         text-sm md:text-base
                         transition-colors duration-300
                         bg-dark text-light hover:bg-light hover:text-dark
                         border-2 border-solid border-dark hover:border-dark
                         dark:bg-light dark:text-dark dark:border-light dark:hover:bg-dark dark:hover:text-light dark:hover:border-light'
              onClick={handleResumeDownload}>
              Resume
            </button>

          </div>

        </div>
      </div>

    </div>
  )

}
